import { render, staticRenderFns } from "./ContactWithYourAM.vue?vue&type=template&id=823abe54&scoped=true"
import script from "./ContactWithYourAM.vue?vue&type=script&lang=js"
export * from "./ContactWithYourAM.vue?vue&type=script&lang=js"
import style0 from "./ContactWithYourAM.vue?vue&type=style&index=0&id=823abe54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823abe54",
  null
  
)

export default component.exports